module.exports = __webpack_public_path__ + "static/media/FR.c3a92898.svg";